export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-background-50 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-3xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
            </div>
          </div>
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-950">移动端畅享</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              51动漫网已针对手机浏览器进行全面优化，打开浏览器即可体验流畅的下拉式阅读和播放。
              无论在地铁上、午休时还是睡前，随时随地追更新番，动漫世界尽在掌中。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-check-line text-secondary-500"></i>
                无需下载
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-check-line text-secondary-500"></i>
                即开即看
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-check-line text-secondary-500"></i>
                流畅体验
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}